@if (store.view.ref()) {
  <app-comment-reply #reply
                     [to]="store.view.ref()!"
                     [tags]="replyTags()"
                     [selectResponseType]="!responseSet()"
                     (save)="onReply($event)" />
  <div class="summary-box" [class.hidden-without-removing]="!comments()">
    <h5 routerLink="./comments" queryParamsHandling="merge" i18n>Comments:</h5>
    <app-thread-summary query="plugin/comment:!plugin/delete"
                        [commentView]="true"
                        [source]="store.view.url()"
                        [newRefs$]="newComment$"
                        [depth]="1"
                        [pageSize]="summaryItems" />
  </div>
  <div class="summary-box thread" [class.hidden-without-removing]="!threads()">
    <h5 routerLink="./thread" queryParamsHandling="merge" i18n>Threads:</h5>
    <app-thread-summary query="plugin/thread:!plugin/comment:!plugin/delete"
                        [source]="store.view.url()"
                        [newRefs$]="newThread$"
                        [depth]="1"
                        [pageSize]="summaryItems" />
    @if (threads() > summaryItems) {
      <a routerLink="./thread"
         queryParamsHandling="merge"
         class="load-more no-select" i18n>
        load more
      </a>
    }
  </div>
  <div class="summary-box" [class.hidden-without-removing]="!responses()">
    <h5 routerLink="./responses" queryParamsHandling="merge" i18n>Responses:</h5>
    <app-ref-list #list [page]="query.page()"
                  [pageControls]="false"
                  [insertNewAtTop]="true"
                  [newRefs$]="newResp$" />
    @if (responses() > summaryItems) {
      <a routerLink="./responses"
         queryParamsHandling="merge"
         class="load-more no-select" i18n>
        more responses
      </a>
    }
  </div>
} @else {
  <app-loading />
}
